var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFloor16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2501,
    height: 1273,
    viewBox: "0 0 2501 1273",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 3,
    d: "M1769.24 163.304H1501.19V273.077H1489.18V651.879H1569.14V582.439H1746.87V245.634H1769.24V163.304Z",
    fill: "#E32009",
    fillOpacity: 0.2,
    stroke: "#E32009",
    strokeWidth: 5.05841
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M958.89 515.91H895.504V651.463H1489.59V273.078H1501.61V162.889H1214.5V185.342H958.89V515.91Z",
    fill: "#E32009",
    fillOpacity: 0.2,
    stroke: "#E32009",
    strokeWidth: 5.05841
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: 4,
    d: "M1490.42 653.958H1589.02H1769.24V1066.86H1740.65H1490.42V653.958Z",
    fill: "#E32009",
    fillOpacity: 0.2,
    stroke: "#E32009",
    strokeWidth: 5.05841
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: 5,
    d: "M1743.55 1128.39V1066.37H1767.58V653.958H2295.38V1128.39H1743.55Z",
    fill: "#E32009",
    fillOpacity: 0.2,
    stroke: "#E32009",
    strokeWidth: 5.05841
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: 6,
    d: "M1843.81 571.842V652.71H2295.38V162.889H2010.92V514.856H1864.54V571.842H1843.81Z",
    fill: "#E32009",
    fillOpacity: 0.2,
    stroke: "#E32009",
    strokeWidth: 5.05841
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M1489 653.5H700.5V888.5H378.5V921H437.5V1066.5L700.5 1061V1142.5H1257V1066.5H1489V653.5Z",
    fill: "#E32009",
    fillOpacity: 0.2,
    stroke: "#E32009",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFloor16);
export default __webpack_public_path__ + "static/media/select-floor-16.814f01c4.svg";
export { ForwardRef as ReactComponent };